import React, { Component } from "react";
import $ from "jquery";
import Modal from "./modal";
import FormContraseñaOlvidada from "./form_contraseña_olvidada";
import { Button, Form, Image, Row, Container, Col, Carousel } from "react-bootstrap";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      contraseñaOlvidada: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.getToken = this.getToken.bind(this);
    this.handleContraseñaOlvidada = this.handleContraseñaOlvidada.bind(this);
    this.contraseñaOlvidadaPost = this.contraseñaOlvidadaPost.bind(this);
  }

  // Función para hacer los setState del formulario (onChange)
  handleInputChange(event) {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  }

  handleContraseñaOlvidada() {
    this.setState({
      contraseñaOlvidada: !this.state.contraseñaOlvidada,
    });
  }

  // Función para la llamada a getToken
  getToken(e) {
    e.preventDefault();
    this.props.submissionHandler({ username: this.state.username, password: this.state.password });
    //console.log(this.props.submissionHandler({ username: this.state.username, password: this.state.password }))
  }

  // Llamada a /reset-password-request por si has olvidado contraseña
  contraseñaOlvidadaPost(event) {
    event.preventDefault();
    let $this = $(this);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/reset-password-request/",
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: {
        email: event.target["email"].value,
      },
    };

    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se le ha enviado un correo", "success");
      })
      .fail(function (response) {
        response = JSON.parse(response.responseText);
        $this[0].props.setAlert("Error - ", "Correo no válido", "danger");
      });
  }

  render() {
    let modalContraseñaOlvidada = this.state.contraseñaOlvidada ? (
      <Modal
        handleButtonShow={this.handleContraseñaOlvidada}
        show={this.state.contraseñaOlvidada}
        form={<FormContraseñaOlvidada contraseñaOlvidadaPost={this.contraseñaOlvidadaPost}></FormContraseñaOlvidada>}
        toogle={"Contraseña Olvidada"}
      />
    ) : null;

    return (
      <React.Fragment>
        {modalContraseñaOlvidada}
        <Carousel controls={false} indicators={false} interval={4000} className="">
          <Carousel.Item>
            <Image style={{ height: "100vh", minWidth: "100vw" }} src="images/Carrusel1.png" alt="First slide" />
          </Carousel.Item>
          <Carousel.Item>
            <Image style={{ height: "100vh", minWidth: "100vw" }} src="images/Carrusel2.png" alt="Third slide" />
          </Carousel.Item>
          <Carousel.Item>
            <Image style={{ height: "100vh", minWidth: "100vw" }} src="images/Carrusel3.png" alt="Third slide" />
          </Carousel.Item>
          <Carousel.Item>
            <Image style={{ height: "100vh", minWidth: "100vw" }} src="images/Carrusel4.png" alt="Fourth slide" />
          </Carousel.Item>
          <Carousel.Item>
            <Image style={{ height: "100vh", minWidth: "100vw" }} src="images/Carrusel5.png" alt="Fifth slide" />
          </Carousel.Item>
          <Carousel.Item>
            <Image style={{ height: "100vh", minWidth: "100vw" }} src="images/Carrusel6.png" alt="Sixth slide" />
          </Carousel.Item>
        </Carousel>
        <Carousel.Caption>
          <Container>
            <Row className="align-items-center vh-100">
              <Col lg={4} sm={12}>
                <Row className="mt-5 pt-5">
                  <Form onSubmit={this.getToken} className="border border-light rounded p-4 shadow-lg login-background">
                    <Form.Group>
                      <Image src={"/images/logoSTJ.png"} alt="logo" fluid />
                    </Form.Group>
                    <Form.Group>
                      <Form.Control
                        required
                        type="email"
                        name="username"
                        placeholder="Usuario"
                        autoComplete="nope"
                        value={this.state.username}
                        onChange={this.handleInputChange}
                        style={{ backgroundColor: "white" }}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Control required type="password" name="password" placeholder="Contraseña" autoComplete="nope" value={this.state.password} onChange={this.handleInputChange} />
                    </Form.Group>

                    <Form.Group>
                      <Button type="submit" variant="outline-dark" className="btn btn-block">
                        Entrar
                      </Button>
                    </Form.Group>
                    <Form.Group>
                      <Button variant="outline" onClick={this.handleContraseñaOlvidada} size="sm">
                        ¿Ha olvidado su contraseña?
                      </Button>
                    </Form.Group>
                  </Form>
                </Row>
              </Col>
              <Col lg={12} sm={5}>
                <h2 className="text-white mr-5-lg text-center login-text">Bienvenida a la base datos</h2>
                {/* TODO: cambiar estilos */}
              </Col>
            </Row>
          </Container>
        </Carousel.Caption>
      </React.Fragment>
    );
  }
}

export default Login;
